import type { ReactNode } from 'react';

export const symbol_universal_currency: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M310-440h-85q-10.83 0-17.92 7.12-7.08 7.11-7.08 18 0 10.88 7.08 17.88 7.09 7 17.92 7h95q17 0 28.5-11.5T360-430v-75q0-14.88-12-24.94T320-540h-70v-50h85q10.83 0 17.92-7.12 7.08-7.11 7.08-18 0-10.88-7.08-17.88-7.09-7-17.92-7H225q-10.83 0-17.92 7.08Q200-625.83 200-615v100q0 10.83 7.08 17.92Q214.17-490 225-490h85v50Zm290 7q-77 0-122.5 26.77T432-334v7q0 6 4.5 10.5T447-312h306q6 0 10.5-4.5T768-327v-7q0-45.46-45.5-72.23Q677-433 600-433Zm0-55q33 0 56.5-23.5T680-568q0-33-23.5-56.5T600-648q-33 0-56.5 23.5T520-568q0 33 23.5 56.5T600-488ZM140-200q-24 0-42-18t-18-42v-440q0-24 18-42t42-18h680q24 0 42 18t18 42v440q0 24-18 42t-42 18H140Zm0-60h680v-440H140v440Zm0 0v-440 440Z"
		/>
	</svg>
);
